import { render, staticRenderFns } from "./Webpush.vue?vue&type=template&id=6a3a0013&scoped=true&"
import script from "./Webpush.js?vue&type=script&lang=js&"
export * from "./Webpush.js?vue&type=script&lang=js&"
import style0 from "./Webpush.scss?vue&type=style&index=0&id=6a3a0013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a0013",
  null
  
)

export default component.exports